import React from 'react'

function SubHeaderTitle({title}) {
  return (
    <div className="subTitle my-3">
        <p className="text-left text-light fw-bold">{title}</p>
        {/* <div style={{borderWidth:0.5,borderBottom:'1px solid gray'}}></div> */}
     </div>
  )
}

export default SubHeaderTitle